import {useState} from "react";
import {AppPage} from "common/Layout";
import {AppDeleteIcon} from "shared/UI/UIKit/icons/Delete";
import {AppDownloadIcon} from "shared/UI/UIKit/icons/Download";
import {AppButton} from "shared/UI/UIKit/Button";
import {AppFlex} from "shared/UI/UIKit/Flex";
import {AppText} from "shared/UI/UIKit/Text";
import type {
  AdditionalMaterialsPage as AdditionalMaterialsPageType,
  ExtraMaterial as ExtraMaterialType
} from "../../config/types";
import {PageType} from "../../config/types";
import {GLOBAL_CONFIG} from "../../config/config";
import styles from "./styles.module.scss";

export const AdditionalMaterialsPage = () => {
  const [currentMaterial, setCurrentMaterial] = useState<ExtraMaterialType | null>(null);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const materialsPage = GLOBAL_CONFIG.pages.find(page => page.type === PageType.ADDITIONAL_MATERIALS) as AdditionalMaterialsPageType;

  if (!materialsPage) {
    return null;
  }

  const downloadPdf = (link: string) => {
    const newWin = window.open("");
    newWin!.location.href = link;
  };

  // const openMaterialModal = (material: ExtraMaterialType) => {
  //   setCurrentMaterial(material);
  //   setOpenModal(true);
  // };

  const closeModal = () => {
    setCurrentMaterial(null);
    setOpenModal(false);
  };

  return (
    <AppPage
          contentClassName={styles.content}
          pageTitle="Дополнительный модуль"
          documentTitle="Дополнительный модуль"
          style={{backgroundImage: `url(${materialsPage.imagePath})`}}
      >
      <AppText size={24}>Дополнительный модуль</AppText>
      {/*<AppFlex className={styles.materials}>*/}
      {/*  {materialsPage.materials.map((item, idx) => (*/}
      {/*    <div className={styles.materialRow} key={"material" + idx}>*/}
      {/*      <AppButton className={styles.materialBtn} onClick={() => openMaterialModal(item)}>Смотреть</AppButton>*/}
      {/*      <AppText size={18} style={{paddingLeft: "20px"}}>{item.title}</AppText>*/}
      {/*    </div>*/}
      {/*  ))}*/}
      {/*</AppFlex>*/}
      <AppFlex className={styles.infoBlock}>
        <AppText className={styles.boldText} size={18}>Дополнительная информация</AppText>
        <AppFlex>
          {materialsPage.filesToDownload.map((item, idx) => (
            <AppFlex key={"fileToDownload" + idx} direction="row" alignItems="center">
              <AppButton onClick={() => downloadPdf(item.link)} className={styles.pdf}>
                <AppDownloadIcon className={styles.downloadIcon}/>Скачать PDF
              </AppButton>
              <AppText size={18}>{item.fileName}</AppText>
            </AppFlex>
            ))}
        </AppFlex>
      </AppFlex>
      <AppFlex className={styles.infoBlock}>
        <AppText className={styles.boldText} size={18}>Рекомендуемая литература:</AppText>
        <ul className={styles.list}>
          {materialsPage.literatures.map((listItem, idx) => (
            <li key={"listItem" + idx} className={styles.listItem}>
              <AppText size={18}>{ listItem }</AppText>
            </li>
            ))}
        </ul>
      </AppFlex>
      <AppFlex className={styles.infoBlock}>
        <AppText className={styles.boldText} size={18}>Нормативные документы:</AppText>
        <ul className={styles.list}>
          {materialsPage.historical.map((listItem, idx) => (
            <li key={"listItem" + idx} className={styles.listItem}>
              <AppText size={18}>{ listItem }</AppText>
            </li>
            ))}
        </ul>
      </AppFlex>
      <AppFlex className={styles.infoBlock}>
        <AppText className={styles.boldText} size={18}>Информационные ресурсы сети Интернет:</AppText>
        <ul className={styles.list}>
          {materialsPage.sites.map((listItem, idx) => (
            <li key={"listItem" + idx} className={styles.listItem}>
              <AppText size={18}>{ listItem }</AppText>
            </li>
            ))}
        </ul>
      </AppFlex>
      {openModal && currentMaterial && (
        <div className={styles.materialModalWrapper}>
          <AppFlex className={styles.materialModal}>
            <AppDeleteIcon className={styles.closeIcon} onClick={closeModal}/>
            <AppText size={32} className={styles.boldText}>{currentMaterial.title}</AppText>
            <iframe width="100%" height="480" src={currentMaterial.link}
                        title="YouTube video player" frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen></iframe>
            <div>
              <AppButton onClick={closeModal}>Закрыть</AppButton>
            </div>
          </AppFlex>
        </div>
        )}
    </AppPage>
  );
};
